export default __webpack_public_path__ + "static/media/45.13228586.jpg";